import { render } from "./Footer.vue?vue&type=template&id=0cfb9066&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=0cfb9066&scoped=true&lang=css"
import "./Footer.vue?vue&type=style&index=1&id=0cfb9066&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cfb9066"]])

export default __exports__